import React from "react";
import { useLocation, Link } from "react-router-dom";

const UrlTag = () => {
    const location = useLocation();
    const formatSegment = (segment) => {
        return segment.split("-").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    };
    const segments = location.pathname
        .split("/")
        .filter(Boolean);

    return (
        <div>
            <div className="w-full bg-[#f0f0f0] py-4 px-4 sm:px-6 md:px-8 lg:px-14">
                <div className="flex flex-wrap items-center">
                    {segments.map((segment, index) => {
                        const path = "/" + segments.slice(0, index + 1).join("/");
                        const formattedSegment = formatSegment(segment);

                        return (
                            <span key={index} className="text-sm sm:text-base md:text-lg lg:text-xl">
                                <Link to={path} className="px-2 opacity-50 hover:opacity-100 hover:font-semibold">
                                    {formattedSegment}
                                </Link>
                                {index < segments.length - 1 && <span className="mx-1">/</span>}
                            </span>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default UrlTag;